import { DisplayDateRange } from 'components/Charting/types';
import {
  NewAssetAvailabilityEntry,
  NewSiteAvailabilityEntry,
} from 'pages/Availability/common/FormDrawer/types';
import {
  BaseAssetAvailabilityEntry,
  BaseSiteAvailabilityEntry,
  Site,
} from 'pages/Availability/types';
import { AvailabilitySlice, Creator } from 'store/types';
import { getTradingDayRange } from 'utils/optimisation';

export type DateRange = { start: Date; end: Date };

export type TableActionType =
  'cancel' | 'end' | 'endAndStartNew' | 'info' | 'edit' | null;

export type AvailabilityUserAction = {
  actionType: TableActionType;
  assetAvailabilityEntry: BaseAssetAvailabilityEntry | null;
  siteAvailabilityEntry: BaseSiteAvailabilityEntry | null;
};

export const createAvailabilitySlice: Creator<AvailabilitySlice> = (set) => {
  const today = new Date();
  const { dateRange } = getTradingDayRange(today);
  return {
    availabilityDateRange: dateRange,
    selectedSiteData: undefined,
    availabilityUserAction: {
      actionType: null,
      assetAvailabilityEntry: null,
      siteAvailabilityEntry: null,
    },
    availabilityFormOpen: false,
    persistedSiteAvailabilityFormData: undefined,
    persistedAssetAvailabilityFormData: undefined,
    persistedEditingId: null,
    setAvailabilityDateRange: (dateRange: DisplayDateRange) =>
      set(() => ({ availabilityDateRange: dateRange })),
    setSelectedSiteData: (site: Site) =>
      set(() => ({ selectedSiteData: site })),
    setAvailabilityUserAction: (state: AvailabilityUserAction) =>
      set((currentState) => ({
        ...currentState,
        availabilityUserAction: state,
      })),
    setAvailabilityFormOpen: (isOpen: boolean) =>
      set((currentState) => ({
        ...currentState,
        availabilityFormOpen: isOpen,
      })),
    setPersistedSiteAvailabilityFormData: (values: NewSiteAvailabilityEntry) =>
      set((currentState) => ({
        ...currentState,
        persistedSiteAvailabilityFormData: values,
      })),
    setPersistedAssetAvailabilityFormData: (
      values: NewAssetAvailabilityEntry,
    ) =>
      set((currentState) => ({
        ...currentState,
        persistedAssetAvailabilityFormData: values,
      })),
    resetPersistedSiteAvailabilityFormData: () => {
      set((currentState) => ({
        ...currentState,
        persistedSiteAvailabilityFormData: undefined,
      }));
    },
    resetPersistedAssetAvailabilityFormData: () => {
      set((currentState) => ({
        ...currentState,
        persistedAssetAvailabilityFormData: undefined,
      }));
    },
    setPersistedEditingId: (id: number | null) =>
      set((currentState) => ({ ...currentState, persistedEditingId: id })),
    resetPersistedEditingId: () =>
      set((currentState) => ({ ...currentState, persistedEditingId: null })),
  };
};
